import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import * as $ from 'jquery';
import { Router, Event, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  constructor(
    translateService: TranslateService,
    private _router: Router) {
    translateService.setDefaultLang(environment.defaultLocale);
    this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => this.setupDesignJS(), 10);
      }
    });
  }

  private setupDesignJS() {
    $('body').on('click', '.form_class .ins_space input, .form_class .ins_space select, .form_class .ins_space textarea', function () {
      $(this).parent().addClass('top');
    });


    $('body').on('change', '.form_class .ins_space input, .form_class .ins_space select, .form_class .ins_space textarea', function () {
      if (!$(this).val()) {
        $(this).parent().removeClass('top');
      }
    });

    $('body').on('keyup', '.form_class .ins_space input, .form_class .ins_space select, .form_class .ins_space textarea', function () {
      $(this).parent().addClass('top');
    })

    $('body').on('blur', '.form_class .ins_space input, .form_class .ins_space select, .form_class .ins_space textarea', function () {
      if (!$(this).val()) {
        $(this).parent().removeClass('top');
      }
    })
  }
}
